/**
 * Rewrite QLASH CDN URLs so they go through the Vite dev proxy. The staging
 * CDN (`stg.cdn.qlash.gg`) returns 403 for anonymous requests; the proxy
 * forwards to the public `cdn.qlash.gg` mirror so the same file ID resolves
 * correctly during development.
 *
 * In production this is a no-op — the deployed origin can fetch the prod CDN
 * directly without proxying.
 */

const CDN_HOSTS = new Set(['stg.cdn.qlash.gg', 'cdn.qlash.gg']);

export function cdnImage(url: string | null | undefined): string | undefined {
  if (!url) return undefined;
  if (!import.meta.env.DEV) return url;
  try {
    const u = new URL(url);
    if (CDN_HOSTS.has(u.hostname)) {
      return `/qlash-cdn${u.pathname}${u.search}`;
    }
  } catch {
    /* not a parseable URL — pass through */
  }
  return url;
}
